<template>
    <v-card outlined ref="info-card">
        <slot />
        <v-divider />
        <v-card-text>
            <v-row class="mx-n4 mt-n4 mb-0" align="center">
                <v-col class="pa-4 font-size-18 font-weight-bold text-truncate">
                    {{ lecture?.subject }}
                </v-col>
                <v-col cols="auto" class="pa-4">
                    <v-chip small outlined>{{ lecture?.meta?.watcherCount?.format?.() }}명 참여</v-chip>
                </v-col>
            </v-row>
            <v-row class="mx-n4 mt-0 mb-n4" align="center" v-if="isUserCompany">
                <v-col cols="12" md="" class="px-4 pt-0 pb-4 font-size-14">
                    <info-link />
                </v-col>
                <v-col cols="12" md="auto" class="px-4 pt-0 pb-4 font-size-14">
                    <info-code />
                </v-col>
                <v-col cols="12" class="pa-4 font-size-14" v-if="0 < lecture?.files?.length || 0 < lecture?.links?.length">
                    <v-chip-group column class="ma-n4">
                        <template v-for="file in lecture?.files">
                            <v-chip :href="file.url" outlined large label width="32" min-width="32" height="32" class="ma-4" download :key="file._id">
                                {{ file.fileName }}
                                <v-icon small class="ml-4"> mdi-download </v-icon>
                            </v-chip>
                        </template>
                        <template v-for="link in lecture?.links">
                            <v-chip :href="link.href" :download="link.isDownload" :target="link.isDownload ? undefined : '_blank'" outlined large label width="32" min-width="32" height="32" class="ma-4" :key="link._id">
                                {{ link.name }}
                                <template v-if="link.isDownload">
                                    <v-icon small class="ml-4"> mdi-download </v-icon>
                                </template>
                                <template v-else>
                                    <v-icon small class="ml-4"> mdi-open-in-new </v-icon>
                                </template>
                            </v-chip>
                        </template>
                    </v-chip-group>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

import InfoCode from "./info/info-code.vue";
import InfoLink from "./info/info-link.vue";

export default {
    components: {
        InfoCode,
        InfoLink,
    },

    computed: {
        ...mapState("lecture", ["lecture"]),
        ...mapGetters("lecture", ["isUserCompany"]),
    },
    methods: {
        ...mapMutations("lecture/chat", ["setHeight"]),
        copy() {
            if (!this.lecture.code.isOn) return;

            let text = this.lecture.code.text;
            navigator.clipboard.writeText(text).then(() => alert("참여코드가 복사되었습니다"));
        },
        setSize() {
            const intervalId = setInterval(() => {
                const infoCardEl = this.$refs["info-card"]?.$el;
                if (infoCardEl) {
                    const [{ height }] = infoCardEl.getClientRects();
                    this.setHeight(height);
                    clearInterval(intervalId);
                }
            }, 10);
        },
    },
    mounted() {
        this.setSize();
        window.addEventListener("resize", this.setSize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setSize);
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-chip {
        &,
        &::before {
            background: none !important;
        }
    }
}
</style>
